module.exports = __webpack_public_path__ + "img/swyxyy_bd.fc28755.png";